/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_VerifyInputs */

const en_mk_team_flow_verify = /** @type {(inputs: Mk_Team_Flow_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 · Combine and check`)
};

const id_mk_team_flow_verify = /** @type {(inputs: Mk_Team_Flow_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 · Gabungkan dan periksa`)
};

/**
* | output |
* | --- |
* | "02 · Combine and check" |
*
* @param {Mk_Team_Flow_VerifyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_verify = /** @type {((inputs?: Mk_Team_Flow_VerifyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_VerifyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_verify(inputs)
	return en_mk_team_flow_verify(inputs)
});